/* eslint-disable jsdoc/require-jsdoc */
import { createAction, props } from '@ngrx/store';
import { EnovacomParams } from '@mona/models';

export const getEnovacomToken = createAction('ENOVACOM:GET_ENOVACOM_TOKEN', props<Omit<EnovacomParams, 'token'>>());
export const getEnovacomTokenSuccess = createAction('ENOVACOM:GET_ENOVACOM_TOKEN_SUCCESS', props<EnovacomParams>());
export const getEnovacomTokenFailure = createAction('ENOVACOM:GET_ENOVACOM_TOKEN_FAILURE', props<{ error: any }>());
